export default __webpack_public_path__ + "static/media/tofu_salad.f623f1f9.mp3";